import { useEffect, useCallback } from 'react';
import { useRoles } from '@/Recoil/Topik/Roles';
import RoleTable from './RoleTable';

const LecturerTable = () => {
    const { roles, byRole, loading, syncUsersByRole, assignUserRole, removeUserRole } = useRoles();

    useEffect(() => {
        syncUsersByRole({ role: 'lecturer' });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const users = byRole.lecturer.map(email => roles[email]).filter(Boolean);

    const handleAdd = useCallback(async (email: string) => {
        await assignUserRole({ email, role: 'lecturer' });
    }, [assignUserRole]);

    const handleRemove = useCallback(async (email: string) => {
        await removeUserRole({ email });
    }, [removeUserRole]);

    return (
        <RoleTable
            role="lecturer"
            users={users}
            loading={loading}
            onAdd={handleAdd}
            onRemove={handleRemove}
        />
    );
};

export default LecturerTable;
